import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { SuiModal, SuiModalService, ComponentModalConfig, ModalSize, DatepickerMode } from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { FinanceService } from '../../services';
interface ITransactionDetailModalContext {
	data: any;
	title?: string;
	isEdit?: boolean;
}
@Component({
	selector: 'app-edit-director-modal',
	templateUrl: './edit-director-modal.component.html',
	styleUrls: [ './edit-director-modal.component.scss' ]
})
export class TransactionDetailModalComponent implements OnInit, OnDestroy {
	searchable: boolean = true;
	public mode: DatepickerMode = 'year';
	public maxDate = new Date();
	private unsubscribe$: Subject<void> = new Subject<void>();
	formSubmitAttempt: boolean;
	success: any;
	error: any;
	pending: boolean;

	companyDirectorForm: FormGroup;
	companyDirector: any;
	invoice: any;
	detailTransaction;
	paymentDetail: any;
	paymentInstructions: any;
	constructor(
		private companySvc: FinanceService,
		private modalService: SuiModalService,
		@Inject(DOCUMENT) private document,
		private fb: FormBuilder,
		public modal: SuiModal<ITransactionDetailModalContext, void, void>
	) {
		this.companyDirectorForm = fb.group({
			firstName: [ '' ],
			lastName: [ '' ],
			middleName: [ '' ],
			gender: [ '' ],
			nationalityId: [ '' ],
			countryOfOriginId: [ '' ],
			nationalIdNumber: [ '' ],
			organizationOwnershipTypeId: [ '' ],
			shareholding: [ '' ]
		});
		this.detailTransaction = modal.context.data;
	}

	submit() {
		this.modal.approve(<any>{
			invoiceDetails: this.detailTransaction,
			paymentDetail: this.paymentDetail
		});
		// this.modal.context.isEdit == true ? this.update() : this.save();
	}
	getTransaction() {}

	getPayment() {
		// );
	}
	save() {}

	update() {}

	nullify() {
		this.success = null;
		this.error = null;
	}
	ngOnInit() {
		// this.document.body.classList.remove('panel');
	}
	// s
	ngOnDestroy(): void {
		// this.document.body.classList.add('panel');
	}
}

export class TransactionDetailModal extends ComponentModalConfig<ITransactionDetailModalContext, void, void> {
	constructor(title: string, data: string, size: ModalSize = ModalSize.Small) {
		super(TransactionDetailModalComponent, { title, data });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = 'slide left';
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
